import React from 'react'
import PropTypes from 'prop-types'
import { ListGroup, Image } from 'react-bootstrap'
import styles from './../style/LkSidebar.module.scss'

const LkSidebar = ({ data, cartCount, logOut, active, user_profile_type }) => {
  const teyca = (
    <>
      <div className={styles.shopsng_svaz}>
        <div>Связаться в</div>
        {/* TG */}
        {'tglink' in data?.page_data &&
          <a href={data?.page_data?.tglink} target="_blank" rel="noopener noreferrer">
            <Image alt="TG" src={data?.page_data?.tgicon || ''} width="20" height="20" />
          </a>
        }
        {/* WA */}
        {'walink' in data?.page_data &&
          <a href={data?.page_data?.walink} target="_blank" rel="noopener noreferrer">
            <Image alt="WA" src={data?.page_data?.waicon || ''} width="20" height="20" />
          </a>
        }
      </div>
    </>
  )

  return (
    <>
      <div className={styles.lk_page_block_topmob}>
        <ListGroup className={styles.lk_page_block_left_list}>
          <ListGroup.Item as="a" href={data?.page_data?.link_lk} className={active == 1 ? styles.lk_page_block_left_mitem_menu_active : styles.lk_page_block_left_mitem_menu}>Профиль</ListGroup.Item>
          <ListGroup.Item as="a" href={data?.page_data?.link_cart} className={active == 2 ? styles.lk_page_block_left_mitem_menu_active : styles.lk_page_block_left_mitem_menu}>
            Корзина
              {cartCount > 0 && (
                <span className={styles.cartCount}>
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
          </ListGroup.Item>
          <ListGroup.Item as="a" href={data?.page_data?.link_orders} className={active == 3 ? styles.lk_page_block_left_mitem_menu_active : styles.lk_page_block_left_mitem_menu}>Мои заказы</ListGroup.Item>
          {user_profile_type == `legal` ?
            <ListGroup.Item as="a" href={data?.page_data?.link_optproducts} className={active == 5 ? styles.lk_page_block_left_mitem_menu_active : styles.lk_page_block_left_mitem_menu}>Продукция</ListGroup.Item>
          :
            <ListGroup.Item as="a" href={data?.page_data?.link_favorite} className={active == 4 ? styles.lk_page_block_left_mitem_menu_active : styles.lk_page_block_left_mitem_menu}>Избранное</ListGroup.Item>
          }
          <ListGroup.Item onClick={logOut} className={styles.lk_page_block_left_mitem_menu}>
            <div>Выйти из аккаунта</div>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.1738 8.52866L11.6672 7.03533L10.1738 5.54199" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.69336 7.03516H11.6259" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.86003 11.6663C4.28169 11.6663 2.19336 9.91634 2.19336 6.99967C2.19336 4.08301 4.28169 2.33301 6.86003 2.33301" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ListGroup.Item>
        </ListGroup>
      </div>
      <div className={styles.lk_page_block_left}>
        <ListGroup className={styles.lk_page_block_left_list}>
          <ListGroup.Item className={styles.lk_page_block_left_mitem_menu}>
            <a className={active == 1 ? styles.lk_page_block_left_mitem_menu_active : ``} href={data?.page_data?.link_lk}>Профиль</a>
            <a className={active == 2 ? styles.lk_page_block_left_mitem_menu_active : ``} href={data?.page_data?.link_cart}>
              Корзина
              {cartCount > 0 && (
                <span className={styles.cartCount}>
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </a>
            <a className={active == 3 ? styles.lk_page_block_left_mitem_menu_active : ``} href={data?.page_data?.link_orders}>Мои заказы</a>
            {user_profile_type == `legal` ?
              <a className={active == 5 ? styles.lk_page_block_left_mitem_menu_active : ``} href={data?.page_data?.link_optproducts}>Продукция</a>
            :
              <a className={active == 4 ? styles.lk_page_block_left_mitem_menu_active : ``} href={data?.page_data?.link_favorite}>Избранное</a>
            }
          </ListGroup.Item>
          <ListGroup.Item onClick={logOut} className={styles.lk_page_block_left_mitem + ` d-none d-lg-flex`}>
            <div>Выйти из аккаунта</div>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.1738 8.52866L11.6672 7.03533L10.1738 5.54199" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.69336 7.03516H11.6259" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.86003 11.6663C4.28169 11.6663 2.19336 9.91634 2.19336 6.99967C2.19336 4.08301 4.28169 2.33301 6.86003 2.33301" stroke="#3A3A3A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ListGroup.Item>
        </ListGroup>
        <div className='d-none d-lg-block w-100'>
          {teyca}
        </div>
      </div>
    </>
  )
}

LkSidebar.propTypes = {
  data: PropTypes.object,
  cartCount: PropTypes.number,
  logOut: PropTypes.func,
  active: PropTypes.number,
  user_profile_type: PropTypes.string
}

export default LkSidebar